import React, { useEffect, useRef, useState } from 'react'
import { IssuesFixScreenWrapper } from './issuesFixScreen.style'
import { useLocation } from "react-router-dom";
import { Breadcrumb, Input, message } from 'antd';
import Spinner from "assets/images/Spinner.gif";
import GenricModal from 'components/comman/modalComponents/modal/modal';
import SecuredServices from 'api/securedServices';
import { IqLink } from 'helper/constants';

export default function IssuesFixScreen() {
    const location = useLocation();
    const data = useRef(location.state);
    const [mcqTestData, setMcqTestData] = useState([]);
    const [testMcqModal, setTestMcqModal] = useState(false);

    const [userInputData, setUserInputData] = useState({
        q_tex: null,
        a_tex: null,
        iq_annotation: null,
        mcq_json: null
    })
    const [disableSubmit, setDisableSubmit] = useState(false);

    const [selectedMathjaxToFormat, setSelectedMathjaxToFormat] = useState("");
    const [showFormattedMathjaxOpen, setShowFormattedMathjaxOpen] = useState(false);
    const [blockSubmitAndTest, setBlockSubmitAndTest] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [seeStudentInaccuracyComments, setSeeStudentInaccuracyComments] = useState(false);

    function validateIqAnnotation(lines) {
        // const insertPattern = /^<<step_insert(?:\s+<<verify=[a-zA-Z_][a-zA-Z0-9_]*>>)?>>$/;
        // const finalPattern = /^<<final(?:\s+<<verify=[a-zA-Z_][a-zA-Z0-9_]*>>)?>>$/;
        // const verifierPattern = /^<<verifier=[a-zA-Z_][a-zA-Z0-9_]*>>$/;
        const insertPattern = /^<<step_insert(?:\s+<<verify=[a-zA-Z_][a-zA-Z0-9_]*>>)?\s*>>/;
        const finalPattern = /^<<final(?:\s+<<verify=[a-zA-Z_][a-zA-Z0-9_]*>>)?\s*>>/;
        const imagePattern = /^<<image(?::\d+)?\s*>>/
        const verifierPattern = /^<<verifier=[a-zA-Z_][a-zA-Z0-9_]*>>$/;
        const errors = [];

        lines = lines.split('\n');
        console.log(lines);

        lines.forEach((line, index) => {
            const lineNumber = index + 1;

            if (line.startsWith('<<')) {
                // Check for proper closure
                if (!line.endsWith('>>')) {
                    errors.push(`Line ${lineNumber}: Missing closing '>>'`);
                    return;
                }

                // Validate insert lines
                if (line.startsWith('<<step_insert')) {
                    if (!insertPattern.test(line)) {
                        errors.push(`Line ${lineNumber}: Invalid <<insert>> format`);
                    }
                }

                // Validate final lines
                else if (line.startsWith('<<final')) {
                    if (!finalPattern.test(line)) {
                        errors.push(`Line ${lineNumber}: Invalid <<final>> format`);
                    }
                }
                // Validate final lines
                else if (line.startsWith('<<image')) {
                    if (!imagePattern.test(line)) {
                        errors.push(`Line ${lineNumber}: Invalid <<image>> format`);
                    }
                }

                // Validate verifier directive
                else if (line.startsWith('<<verifier')) {
                    if (!verifierPattern.test(line)) {
                        errors.push(`Line ${lineNumber}: Invalid <<verifier>> format`);
                    }
                }
                // Any other lines starting with '<<'
                else {
                    errors.push(`Line ${lineNumber}: Unknown directive`);
                }
            }
        });

        return errors;
    }

    const saveAndTestChanges = () => {
        setBlockSubmitAndTest(true);
        setDisableSubmit(true);
        if (data.current.type === "iq") {
            let data1 = {
                id: data.current.id,
                q_tex: userInputData.q_tex,
                a_tex: userInputData.a_tex,
                iq_annotation: userInputData.iq_annotation,
                mcq_json: userInputData.mcq_json,
                concept_id: data.current.concept_id,
                instance_id: data.current.instance_id,
                type: data.current.type,
                prod_id: data.current.prod_id,
            }
            let submitflag = 1;
            let errors = validateIqAnnotation(data1.iq_annotation);
            console.log(errors);
            if (errors.length > 0) {
                submitflag = 0;
                message.error(errors.join('\n'));
                setDisableSubmit(false);
                setBlockSubmitAndTest(false);
            }

            if(submitflag == 1){
                SecuredServices.saveAndTestReportedIssueFix(data1).then((res) => {
                    console.log(res.data);
                    if (res.data.status == 1) {
                        message.success(res.data.message);
                        window.open(`${IqLink}ip-verify/${data.current.token}/${-1}/${res.data.data.q_id}`, '_blank');
                    }
                    else {
                        message.error(res.data.message);
                    }
                }).catch((err) => {
                    console.log(err);
                    message.error("Something went wrong, please try again");
                }).finally(() => {
                    setBlockSubmitAndTest(false);
                    setDisableSubmit(false);
                })
            }
           

        }
        else {
            setBlockSubmitAndTest(false);
            setDisableSubmit(false);
            if(!checkIfAllMcqJsonAreValid()){
                return;
            }
            let mcqtestd = userInputData.mcq_json.map((item, index) => {
                return {index:index+1,mcq_json:item}
            })
            setMcqTestData(mcqtestd);
            setTestMcqModal(true);
        }


    }

    const checkIfAllMcqJsonAreValid = ()=>{
        let flag = 1;
        userInputData.mcq_json.forEach((item, index) => {
            try {
                if (item == "") {
                    message.error("Please enter valid mcq json for question " + (index + 1));
                    flag = 0;
                }
                let d = JSON.parse(item);
            } catch (error) {
                message.error("Please enter valid mcq json for question " + (index + 1));
                message.error(error);
                flag = 0;
            }
        })

        if(flag == 0){
            return false;
        }
        else{
            return true;
        }
            
    }

    const handleSubmit = () => {
        setBlockSubmitAndTest(true);
        setDisableSubmit(true);
        if(data.current.type == "mcq" && !checkIfAllMcqJsonAreValid()){
            return;
        }
        let mcqtempdata = [];
        userInputData.mcq_json.forEach((item, index) => {
            mcqtempdata.push(JSON.parse(item));
        })
        mcqtempdata = JSON.stringify(mcqtempdata);
       
        let data1 = {
            id: data.current.id,
            q_tex: userInputData.q_tex,
            a_tex: userInputData.a_tex,
            iq_annotation: userInputData.iq_annotation,
            mcq_json: mcqtempdata, //userInputData.mcq_json,
            concept_id: data.current.concept_id,
            instance_id: data.current.instance_id,
            type: data.current.type,
            prod_id: data.current.prod_id,
        }

        let submitflag = 1;
        if(data.current.type =="iq"){
          
            let errors = validateIqAnnotation(data1.iq_annotation);
            console.log(errors);
            if (errors.length > 0) {
                submitflag = 0;
                message.error(errors.join('\n'));
                setDisableSubmit(false);
                setBlockSubmitAndTest(false);
            }
        }
        if(submitflag == 1){
            SecuredServices.submitIssueReportedAfterFix(data1).then((res) => {
                console.log(res.data);
                if (res.data.status == 1) {
                    message.success(res.data.message);
                    window.history.back();
                }
                else {
                    message.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                message.error("Something went wrong, please try again");
            }).finally(() => {
                setBlockSubmitAndTest(false);
                setDisableSubmit(false);
    
            })
        }
       
    }

    useEffect(() => {
        console.log(data);
        let tempjson = [];
        if(data.current.type =="mcq"){
            let tempData = JSON.parse(data.current.mcq_json);
            tempData.forEach((item) => {
                tempjson.push(JSON.stringify(item));
                })
    
        }  
        setUserInputData({
            q_tex: data.current.q_tex,
            a_tex: data.current.a_tex,
            iq_annotation: data.current.iq_annotation,
            mcq_json: tempjson,
        })

    }, [data])

    useEffect(()=>{
        console.log(userInputData);
    },[userInputData])



    return (
        <IssuesFixScreenWrapper>

            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item onClick={() => { window.history.back() }}>Pending Issues</Breadcrumb.Item>
                <Breadcrumb.Item>Issue - {data.current.id}</Breadcrumb.Item>
            </Breadcrumb>
            <div className='FixReportIssuesParent' >

                <div className='ShowImagesParent'>
                    <button className='showImages' onClick={() => setSeeStudentInaccuracyComments(true)}>See Student Inaccuracy Comments</button>
                </div>

                <div className='step2Form' >
                    <div className='submitImagesTextParent'>
                        <p className='submitImagesText'>Review Comments and Fix the Issues</p>
                    </div>
                    {
                        data.current.type == "iq" ? 
                        <div>
                            <div className='submitExactform'>
                                <label htmlFor="" className='label'>Cleaned Q-Tex:</label>
                                <Input.TextArea rows={3}
                                    placeholder='Enter your Q-Tex here'
                                    value={userInputData.q_tex}
                                    name=""
                                    onChange={(e) => setUserInputData({ ...userInputData, q_tex: e.target.value })}
                                />
                                <div className='showFormatted'>
                                    <div className='showFormattedQtex' onClick={() => {
                                        setSelectedMathjaxToFormat(userInputData.q_tex);
                                        setShowFormattedMathjaxOpen(true);
                                    }}>
                                        <p>Formatted Q-Tex</p>
                                    </div>
                                </div>

                            </div>

                            <div className='submitExactform'>
                                <label htmlFor="" className='label'>Cleaned A-Tex:</label>
                                <Input.TextArea
                                    rows={3}
                                    value={userInputData.a_tex}
                                    placeholder='Enter your A-Tex here'
                                    name=""
                                    onChange={(e) => setUserInputData({ ...userInputData, a_tex: e.target.value })}
                                />
                                <div className='showFormatted'>
                                    <div className='showFormattedQtex' onClick={() => {
                                        setSelectedMathjaxToFormat(userInputData.a_tex);
                                        setShowFormattedMathjaxOpen(true);
                                    }}>
                                        <p>Formatted A-Tex</p>
                                    </div>
                                </div>
                            </div>
                            <div className='submitExactform'>
                                <label htmlFor="" className='label'>Annotated Tex:</label>
                                <Input.TextArea
                                    value={userInputData.iq_annotation}
                                    placeholder='Enter your Annotated Tex here'
                                    name=""
                                    rows={5}
                                    onChange={(e) => setUserInputData({ ...userInputData, iq_annotation: e.target.value })}
                                />
                                <div className='showFormatted'>
                                    <div className='showFormattedQtex' onClick={() => {
                                        const output =userInputData?.iq_annotation.replace(/(?:\\\(|\b)?\\input\[(\d+)](?:\\\))?/g, '\\input[][2em]{$1}^\\circ');
                                        // let output = userInputData?.iq_annotation?.replace(/\\input\[(.+?)\]/g, 'input($1)');
                                        // output = output.replace(/\\\((input\(.+?\))\\\)/g, '$1');
                                        console.log(output);
                                        setSelectedMathjaxToFormat(output);
                                        setShowFormattedMathjaxOpen(true);
                                    }}>
                                        <p>Formatted Iq Annotation</p>
                                    </div>
                                </div>
                            </div>
                        </div> :
                         <div className='submitExactform'>
                            {
                                userInputData.mcq_json?.map((item,i) => {
                                    return <div className='mcqJson'>
                                        <p className='label'>Mcq {i+1}</p>
                                        <Input.TextArea rows={6}
                                    placeholder='Input Mcq Json'
                                    value={item}
                                    name=""
                                    onChange={(e) => {
                                        try {
                                            // Parse the updated JSONonsole.log(console.log(e.target.value));
                                            console.log(e.target.value);
                                            const updatedJson = e.target.value;

                                            let mcqJson =userInputData.mcq_json;
                                            mcqJson[i] = updatedJson;
                                            console.log(mcqJson);
    
                                            // Create a new copy of userInputData
                                            const data = {
                                                ...userInputData,
                                                mcq_json: mcqJson,
                                            };
                                            // Set the new state
                                            setUserInputData(data);

                                        } catch (error) {
                                            console.error("Invalid JSON input:", error);
                                            // throw error;
                                        }
                                    }}
                                />
                                    </div>
                            
                                })
                            }
                          
                        </div>
                    }



                    <div className={blockSubmitAndTest ? "saveAndTestButton block" : 'saveAndTestButton '} onClick={() => saveAndTestChanges()}>
                        <button>{blockSubmitAndTest ? <div><img src={Spinner} width={20} /> processing</div> : "Save and Test"} </button>
                    </div>
                    <div className='buttonsSections'>
                        <div className='submitButton' onClick={() => handleSubmit()} style={{ pointerEvents: disableSubmit ? "none" : "auto", opacity: disableSubmit ? 0.5 : 1 }}>
                            <p>Submit</p>
                        </div>
                    </div>

                </div>


            </div>


            <GenricModal
                title="Show Formatted MathJax"
                isOpen={showFormattedMathjaxOpen}
                toggle={() => setShowFormattedMathjaxOpen(false)}
                width={900}
                data={{ mathjax: selectedMathjaxToFormat }}
            />
            <GenricModal
                title="Reported Issue Comments"
                isOpen={seeStudentInaccuracyComments}
                toggle={() => setSeeStudentInaccuracyComments(false)}
                width={900}
                data={data.current}
            />

            <GenricModal
                closable={true}
                width={900}
                data={mcqTestData}
                title={"Test Mcq Questions"}
                isOpen={testMcqModal}
                toggle={() => setTestMcqModal(false)}
            />


        </IssuesFixScreenWrapper>
    )
}
